import PropTypes from 'prop-types'
import { gql } from '@apollo/client'
import { listingListFragment, listingListFragmentPropTypes } from '~/graphql/fragments/listingList'

export const listingsFragment = gql`
  fragment listings on ListingConnection {
    edges {
      node {
        ...listingList
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }

  ${listingListFragment}
`

export const listingsFragmentPropTypes = PropTypes.shape({
  edges: PropTypes.arrayOf(
    PropTypes.shape({
      node: listingListFragmentPropTypes,
    })
  ),
  pageInfo: PropTypes.shape({
    endCursor: PropTypes.string,
    hasNextPage: PropTypes.bool.isRequired,
  }).isRequired,
})
